import basementsports from "../Assets/basementsports.png";
import softbd from "../Assets/softbd.png";
import digitruck from "../Assets/digitruck.webp";

export default [
  {
    title: "Sr. Full Stack Mobile Engineer",
    companyName: "BasementSports (USA - Remote)",
    icon: basementsports,
    iconBg: "#383E56",
    date: "May 2022 - Currently working",
    points: [
      "⭐️ Orchestrated streaming feature in mobile and web, attracting <b style='color: gold;'>5-10 investors</b> from USA.",
      "⭐️ Influenced <b style='color: gold;'>50K new users</b> via World Cup 2022 NFTs on Polygon Blockchain.",
      "⭐️ Enhanced SOLANA token volume to <b style='color: gold;'>$200K</b> via Volume Bot.",
      "⭐️ Improved clock function, achieving <b style='color: gold;'>22%</b> better mobile app performance.",
      "⭐️ Engineered stripe & IAP for Mobile to MINT <b style='color: gold;'>64K NFTs</b>.",
      "⭐️ Established custom Next.js SSR iframe video player for Twitter and Discord, boosting app <b style='color: gold;'>traffic by 50%</b>.",
      "⭐️ Improved payment processing by <b style='color: gold;'>90%</b> through Stripe & IAP.",
    ],
    skills: [
      "React Native",
      "React",
      "Node.js",
      "Blockchain",
      "MongoDB",
      "GraphQL",
      "Next.js",
      "AWS S3",
      "Stripe",
    ],
  },
  {
    title: "Full Stack Software Engineer",
    companyName: "SoftBD (Bangladesh)",
    icon: softbd,
    iconBg: "#E6DEDD",
    date: "Jan 2021 - April 2022",
    points: [
      "⭐️ Boosted e-commerce orders to <b style='color: gold;'>$35M</b> by Bike-Offer feature.",
      "⭐️ Delivered lottery system that attracted over <b style='color: gold;'>100K users</b>.",
      "⭐️ Assembled <b style='color: gold;'>5 payment gateways</b>, resulting in daily transactions of $0.1M.",
      "⭐️ Improved database schema for <b style='color: gold;'>1M active users</b>.",
      "⭐️ Supervised R&D team to implement RabbitMQ in 7 microservices, boosting database <b style='color: gold;'>transaction speed by 40%</b>.",
      "⭐️ Coordinated efficient backend data systems to facilitate employment for over <b style='color: gold;'>10K youths</b>.",
    ],
    skills: [
      "React Native",
      "React",
      "Node.js",
      "MySQL",
      "RabbitMQ",
      "MicroService",
      "Payment Gateway",
    ],
  },
  {
    title: "Software Engineer",
    companyName: "DigiTruck (Bangladesh)",
    icon: digitruck,
    iconBg: "#383E56",
    date: "March 2019 - Dec 2020",
    points: [
      "⭐️ Initiated 3 secure Bangladeshi payment gateway in app, handling over <b style='color: gold;'>30k transactions of users</b>.",
      "⭐️ Developed a landing page that drew <b style='color: gold;'>2-3 investors</b>.",
      "⭐️ Coded admin dashboard that reduced time for company's administrative departments by <b style='color: gold;'>50%</b>.",
    ],
    skills: ["React", "Node.js", "MongoDB", "Payment Gateway"],
  },
];
